import { throttle } from 'lodash';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import 'flickity-bg-lazyload';
import 'flickity-fade';
import Isotope from 'isotope-layout';

const AMROP = {};
window.AMROP = AMROP;
(() => {
  const gMapScript = 'https://maps.googleapis.com/maps/api/js?key=';
  let winSize = 0;
  const SCREENMDMAX = 1199;
  const TABLET_LANDSCAPE = 1024;
  const SCREEN_SM_MAX = 767;
  const calcWinSize = () => {
    winSize = { width: window.innerWidth, height: window.innerHeight };
  };

  const scrollTo = (elt, duration, target, offset = 0) => {
    // console.log('scrollto', elt, duration, target, offset);
    const anchorHeightAdjust = 30;
    let _scrollTo = elt.getBoundingClientRect().top + window.pageYOffset;
    if (_scrollTo > anchorHeightAdjust) {
      _scrollTo = _scrollTo - anchorHeightAdjust - offset;
    }
    gsap.to(
      window,
      {
        duration: duration || 1,
        scrollTo: _scrollTo,
        onComplete: () => {
          if (target !== undefined) {
            // window.location.hash = target;
          }
        },
      },
    );
  };

  const scrollToId = (href) => {
    if (href !== undefined) {
      const target = href.split('#')[1];
      if (document.getElementById(target) !== null) {
        scrollTo(document.getElementById(target), 1, target);
      }
    }
  };

  // flatten object by concatting values
  const concatValues = (obj) => {
    let value = '';
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        value += obj[prop];
      }
    }
    return value;
  }

  class DDMenuItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('button');
      this.DOM.content = this.DOM.elt.querySelector('.menu-item__level');
      this.isOpen = this.DOM.elt.classList.contains('is-selected');
      this.init();
    }

    init() {
      const self = this;
      this.DOM.btn.addEventListener('click', self.toggleCurrent.bind(self));
    }

    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        gsap.to(this.DOM.content, { duration: 0.3, height: 'auto' });
        this.DOM.elt.classList.add('is-selected');
      } else {
        gsap.to(this.DOM.content, { duration: 0.3, height: 0 });
        this.DOM.elt.classList.remove('is-selected');
      }
    }
  }

  class MainNav {
    constructor() {
      const self = this;
      if (document.querySelector('.main-nav-wrapper')) {
        self.DOM = { elt: document.querySelector('.main-nav-wrapper') };
        self.DOM.toggleBtn = document.querySelector('.burger-btn');
        self.isMenuOpen = false;
        self.initEvents();
      }
    }

    initEvents() {
      const self = this;
      self.DOM.toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (self.isMenuOpen) {
          self.toggle('close');
          document.querySelector('body').classList.remove('is-menu-open');
        } else {
          self.toggle('open');
          document.querySelector('body').classList.add('is-menu-open');
        }
      });

      if (AMROP.Util.hasTouchScreen() || winSize.width < 1200) {
        self.menuItems = [];
        Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach(item => this.menuItems.push(new DDMenuItem(item)));
      }
    }

    toggle(action) {
      this.isMenuOpen = action === 'open';

      if (this.isMenuOpen) {
        this.DOM.elt.classList.add('is-open');
        this.DOM.toggleBtn.classList.add('is-active');
      } else {
        this.DOM.toggleBtn.classList.remove('is-active');
        this.DOM.elt.classList.remove('is-open');
      }
    }
  }

  class StickyNav {
    constructor() {
      const self = this;
      self.DOM = { elt: document.querySelector('[data-menu-type="sticky"]') };
      self.isSticky = false;
      console.log('StickyNav::init');
      self.initEvents()
    }

    initEvents() {
      const self = this;
      window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
    }

    onScroll(e) {
      const windowScrollY = window.scrollY;
      //200
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }

  class AccordionMenuItem {
    constructor(elt, opts) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('.c-accordion-menu__btn');
      this.DOM.link = this.DOM.elt.querySelector('.c-accordion-menu__link');
      this.DOM.content = this.DOM.elt.querySelector('.c-accordion-menu__content');
      this.isOpen = this.DOM.elt.classList.contains('is-active')
      this.opts = opts;
    }
    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      var self = this;
      if (action === 'SHOW') {
        gsap.to(self.DOM.content, { duration: 0.6, height: 'auto' });
        if (self.DOM.btn && self.opts.scrollTo === true) {
          scrollTo(self.DOM.btn, 1, null, 100);
        }
        self.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(self.DOM.content, {
          duration: 0.4, height: 0, onComplete: () => {
            self.DOM.elt.classList.remove('is-active');
          }
        });
      }
    }
  }

  class AccordionMenu {
    constructor(elt) {
      const self = this;
      self.DOM = { elt };
      self.settings = self.DOM.elt.hasAttribute('data-accordion') ? JSON.parse(self.DOM.elt.getAttribute('data-accordion')) : {};
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.c-accordion-menu__item')).forEach(item => self.menuItems.push(new AccordionMenuItem(item, self.settings)));
      self.init();
      console.log("AccordioMenu");
    }

    init() {
      this.current = 0;
      this.initEvents();
      if (typeof this.settings !== 'undefined' && 'autoOpen' in this.settings) {
        this.showContent(this.settings.autoOpen);
      }
    }

    initEvents() {
      for (const [pos, item] of this.menuItems.entries()) {
        if (item.DOM.btn) {
          item.DOM.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
        if (item.DOM.link) {
          item.DOM.link.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
      }
    }

    showContent(pos) {
      console.log('POS', pos);
      if (typeof this.settings !== 'undefined' && 'autoClose' in this.settings) {
        if (this.current !== pos && this.menuItems[this.current].isOpen) {
          this.menuItems[this.current].hide();
        }
      }
      this.menuItems[pos].toggleCurrent();
      this.current = pos;
    }
  }

  class Carousels {
    constructor(element) {
      if (element.querySelector('.js-carousel')) {
        console.log('Carousels::init', element.querySelectorAll('.js-carousel').length);
        const self = this;
        self.DOM = {
          elts: [],
          eltWrapper: element,
        };
        element.querySelectorAll('.js-carousel').forEach((elt) => {
          self.DOM.elts.push(elt);
        });
        self.flcks = [];
        self.init();
      }
    }
    init() {
      let idx = 0;
      const self = this;
      self.DOM.elts.forEach((instance) => {
        console.log('Carousels::init', idx);
        const flck = new Flickity(instance);
        if (self.DOM.eltWrapper.querySelector('.btn--next') && self.DOM.eltWrapper.querySelector('.btn--prev')) {
          self.DOM.eltWrapper.querySelector('.btn--next').addEventListener('click', (e) => {
            e.preventDefault();
            flck.next(true, false);
          });
          self.DOM.eltWrapper.querySelector('.btn--prev').addEventListener('click', (e) => {
            e.preventDefault();
            flck.previous(true, false);
          });
        }
        if (self.DOM.eltWrapper.querySelector('.btn--back')) {
          self.DOM.eltWrapper.querySelector('.btn--back').addEventListener('click', (e) => {
            e.preventDefault();
            flck.select(0);
          });
        }
        self.flcks.push(flck);
        idx += 1;

        // background carousel
        if (self.DOM.eltWrapper.querySelector('.c-carousel__controls')) {
          if (self.DOM.eltWrapper.classList.contains('c-carousel-bg')) {
            console.log('Carousels::wbg');
            const colors = ['blue', 'red', 'red', 'blue-dark', 'cyan', 'purple', 'orange', 'green'];
          }
          self.btns = self.DOM.eltWrapper.querySelectorAll('.c-carousel__controls button');
          self.btns.forEach((item) => {
            // console.log('button', item);
            item.addEventListener('click', (e) => {
              const btn = e.target;
              self.btns.forEach((elt) => elt.classList.remove('is-active'));
              if (btn.hasAttribute("data-id")) {
                const index = btn.getAttribute("data-id");
                flck.select(index, false, false);
                btn.classList.add('is-active');
              }
            });
          });
          if (self.DOM.eltWrapper.querySelector('select')) {
            self.DOM.eltWrapper.querySelector('select').addEventListener('change', (e) => {
              flck.select(e.target.value, false, false);
            });
          }
        }
      });
    }
  }

  class Search {
    constructor(elt) {
      if (document.querySelector(elt)) {
        this.DOM = {
          elt: document.querySelector(elt),
        };
        this.DOM.openBtn = document.querySelector('#btn-search');
        this.DOM.closeBtn = this.DOM.elt.querySelector('.btn--close');
        this.DOM.searchInput = this.DOM.elt.querySelector('.c-search__input');

        this.init();
      }
    }

    init() {
      this.initEvents();
    }

    initEvents() {
      this.DOM.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.openSearch();
      });
      this.DOM.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeSearch();
      });
      document.addEventListener('keyup', (e) => {
        if (e.keyCode === 27) {
          this.closeSearch();
        }
      });
    }

    openSearch() {
      this.DOM.elt.classList.add('c-search--open');
      this.DOM.searchInput.focus();
    }

    closeSearch() {
      this.DOM.elt.classList.remove('c-search--open');
      this.DOM.searchInput.blur();
      this.DOM.searchInput.value = '';
    }
  }

  class SiteSelector {
    constructor(elt) {
      if (document.querySelector(elt)) {
        this.DOM = {
          elt: document.querySelector(elt),
        };
        this.DOM.toggleBtn = document.querySelector('#btn-site-selector');
        this.DOM.ddList = document.querySelector('.c-site-selector-list');
        this.isOpen = this.DOM.ddList.classList.contains('is-active');
        this.init();
      }
    }

    init() {
      this.initEvents();
    }

    initEvents() {
      this.DOM.toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle();
      });
    }

    toggle() {
      if (this.isOpen) {
        this.DOM.ddList.classList.remove('is-active');
        this.DOM.elt.classList.remove('is-active');
        this.isOpen = false;
      } else {
        this.DOM.ddList.classList.add('is-active');
        this.DOM.elt.classList.add('is-active');
        this.isOpen = true;
      }
    }
  }

  class CardRevealItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('.btn--reveal');
      this.DOM.content = this.DOM.elt.querySelector('.c-card__caption');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
    }
    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        this.DOM.elt.classList.add('is-active');
        gsap.to(this.DOM.content, { duration: 0.3, y: 0, opacity: 1, visibility: "visible", delay: 0.3 });
      } else {
        this.DOM.elt.classList.remove('is-active');
        gsap.to(this.DOM.content, { duration: 0.3, y: 10, opacity: 0, visibility: "hidden" });
      }
    }
  }

  class CardReveal {
    constructor(elt) {
      this.DOM = { elt };
      this.items = [];
      Array.from(this.DOM.elt.querySelectorAll('.c-card--reveal')).forEach(item => this.items.push(new CardRevealItem(item)));
      this.init();
    }

    init() {
      this.current = 0;
      this.initEvents();
    }

    initEvents() {
      for (const [pos, item] of this.items.entries()) {
        if (item.DOM.btn) {
          item.DOM.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
      }
    }

    showContent(pos) {
      console.log('POS', pos);
      if (this.current !== pos && this.items[this.current].isOpen) {
        this.items[this.current].hide();
      }
      this.items[pos].toggleCurrent();
      this.current = pos;
    }
  }

  class SideNav {
    constructor() {
      if (document.querySelector('.c-side-filter')) {
        const self = this;
        self.DOM = { elt: document.querySelector('.c-side-filter') };
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.openBtn = self.DOM.elt.querySelector('.btn-toggle');
        self.isOpen = false;
        self.initEvents();
      }
    }
    initEvents() {
      this.DOM.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.isOpen) {
          this.toggle('close');
        } else {
          this.toggle('open');
        }
      });
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.DOM.elt.classList.add('is-open');
        self.DOM.openBtn.classList.add('is-active');
      } else {
        self.DOM.elt.classList.remove('is-open');
        self.DOM.openBtn.classList.remove('is-active');
      }
    }
  }

  class CookieConsent {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.closeBtn = this.DOM.elt.querySelector('#c-content-agree');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.settings = JSON.parse(this.DOM.elt.getAttribute('data-setting'));
      this.initEvents();
      if (this.settings.alwaysVisible) {
        this.show();
      } else {
        this.cookieHandler();
      }
    }

    initEvents() {
      this.DOM.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
        if (!this.settings.alwaysVisible) {
          this.constructor.setCookie(this.settings.id, this.settings.postedOn, 60);
          console.log('cookie set');
        }
      });
    }

    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }

    toggle(action) {
      var self = this;
      if (action === 'SHOW') {
        gsap.to(self.DOM.elt, { duration: 0.6, height: 'auto' });
        self.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(self.DOM.elt, {
          duration: 0.4, height: 0, onComplete: () => {
            self.DOM.elt.classList.remove('is-active');
          }
        });
      }
    }

    cookieHandler() {
      const cookie = this.constructor.getCookie(this.settings.id);
      if (cookie === '' || (cookie !== '' && cookie !== this.settings.postedOn)) {
        this.show();
      } else if (cookie !== '' && cookie === this.settings.postedOn) {
        this.hide();
      }
    }

    static setCookie(id, value, expiryDays) {
      let date = new Date();
      date.setTime(date.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = `${id}= ${value}; ${expires}; path=/`;
    }

    static getCookie(cname) {
      const name = `${cname}=`;
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }
  }

  AMROP.GMap = {
    load: () => {
      if (typeof AMROP.GMap.isLoaded === 'undefined') {
        const self = AMROP.GMap;
        AMROP.GMap.isLoaded = false;
        self.isLoaded = false;
        self.DOM = {
          elt: document.getElementById('gmap'),
          zoomInBtn: document.getElementById('gmap-zoom-in'),
          zoomOutBtn: document.getElementById('gmap-zoom-out'),
        };
        self.settings = JSON.parse(self.DOM.elt.getAttribute('data-settings'));
        self.marker = self.settings.marker;
        self.locations = self.settings.locations;
        self.zoom = parseInt(self.settings.zoom, 0) || 14;
        self.apiKey = self.DOM.elt.getAttribute('data-gmapkey');
        self.markers = [];
        const script = document.createElement('script');
        script.addEventListener('load', AMROP.GMap.loaded);
        script.src = `${gMapScript + self.apiKey}&callback=window.AMROP.GMap.init&loading=async`;
        document.body.appendChild(script);
      } else {
        AMROP.GMap.loaded();
        AMROP.GMap.init();
      }
    },
    loaded: () => {
      AMROP.GMap.isLoaded = true;
    },
    init: () => {
      if (google.maps) {
        console.log('AMROP.GMap::init');
        const self = AMROP.GMap;
        let marker;
        const center = {
          lng: parseFloat(self.locations[0].lng),
          lat: parseFloat(self.locations[0].lat),
        };

        self.styles = {
          light: [
            {
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f5f5f5',
                },
              ],
            },
            {
              elementType: 'labels.icon',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#616161',
                },
                {
                  visibility: 'off',
                },
              ],
            },
            {
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#f5f5f5',
                },
              ],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#bdbdbd',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#eeeeee',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#757575',
                },
              ],
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e5e5e5',
                },
              ],
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#9e9e9e',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#ffffff',
                },
              ],
            },
            {
              featureType: 'road.arterial',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#757575',
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dadada',
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#616161',
                },
              ],
            },
            {
              featureType: 'road.local',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#9e9e9e',
                },
              ],
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e5e5e5',
                },
              ],
            },
            {
              featureType: 'transit.station',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#eeeeee',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#c9c9c9',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#9e9e9e',
                },
              ],
            },
          ],
          dark: [{
            elementType: "geometry",
            stylers: [{
              color: "#00508f"
            }, {
              saturation: 100
            }]
          }, {
            featureType: "administrative",
            elementType: "labels.text",
            stylers: [{
              color: "#0069ab"
            }]
          }, {
            featureType: "administrative",
            elementType: "labels.text.stroke",
            stylers: [{
              visibility: "off"
            }]
          }, {
            featureType: "landscape",
            elementType: "labels.text.stroke",
            stylers: [{
              visibility: "off"
            }]
          }, {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [{
              color: "#0069ab"
            }]
          }, {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [{
              visibility: "off"
            }]
          }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
              color: "#0069ab"
            }]
          }, {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{
              color: "#0069ab"
            }, {
              saturation: 100
            }]
          }, {
            featureType: "poi",
            elementType: "labels",
            stylers: [{
              visibility: "off"
            }]
          },
          {
            featureType: "all",
            elementType: "labels.text.fill",
            stylers: [{
              gamma: 0.01
            },
            {
              lightness: 20
            },
            {
              weight: "1.39"
            },
            {
              color: "#f2f2f2"
            }
            ]
          },
          {
            featureType: "all",
            elementType: "labels.text.stroke",
            stylers: [{
              weight: "0.96"
            },
            {
              saturation: "9"
            },
            {
              visibility: "on"
            },
            {
              color: "#000000"
            }
            ]
          },
          {
            featureType: "administrative.country",
            elementType: "labels",
            stylers: [
              {
                color: "#0069ab"
              }
            ]
          },
          {
            featureType: "administrative.province",
            elementType: "labels",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
              color: "#003b68"
            }]
          }, {
            featureType: "water",
            elementType: "labels",
            stylers: [{
              color: "#0069ab"
            }]
          },
          ],
        };

        const theme = (self.settings.theme !== 'undefined' && self.settings.theme === 'dark') ? self.styles.dark : self.styles.light;
        self.map = self.createMap(self.DOM.elt, center, self.zoom, theme);
        self.locations.forEach((location, index) => {
          const id = index;
          marker = AMROP.GMap.createMarker(
            self.map,
            location.id,
            location.title,
            location.description,
            location.url,
            location.lng,
            location.lat,
            location.marker,
          );
          google.maps.event.addListener(marker, 'click', () => {
            self.onMarkerClicked(self.map, self.markers[id].marker);
            self.map.setZoom(self.zoom);
          });
          self.markers.push({ id: location.id, marker });
        });
        self.initEvents();

        if (self.locations.length == 1) {
          self.map.setZoom(self.zoom);
        } else if (AMROP.Util.hasTouchScreen() && winSize.width > SCREEN_SM_MAX) {
          console.log('GMAP::autocenter...');
          self.autoCenter(self.map);
        }
      }
    },
    initEvents: () => {
      const self = AMROP.GMap;
      if (self.DOM.zoomInBtn) {
        google.maps.event.addDomListener(self.DOM.zoomInBtn, 'click', () => {
          const currentZoomLevel = self.map.getZoom();
          if (currentZoomLevel !== 21) {
            self.map.setZoom(currentZoomLevel + 1);
          }
        });
      }

      if (self.DOM.zoomInBtn) {
        google.maps.event.addDomListener(self.DOM.zoomOutBtn, 'click', () => {
          const currentZoomLevel = self.map.getZoom();
          if (currentZoomLevel !== 0) {
            self.map.setZoom(currentZoomLevel - 1);
          }
        });
      }
    },
    createMarker: (map, id, title, body, url, lng, lat, markerIco) => {
      return new google.maps.Marker({
        position: { lat: parseFloat(lat), lng: parseFloat(lng) },
        id: id || parseInt(Math.random() * 10000, 0),
        map,
        title: title || '',
        body: body || '',
        icon: markerIco || 'img/map-marker.png',
        animation: google.maps.Animation.DROP,
      });
    },
    createMap: (elt, coordinates, zoom, style) => {
      return new google.maps.Map(document.getElementById('gmap'), {
        zoom: zoom || 4,
        center: coordinates,
        disableDefaultUI: true,
        styles: style,
      });
    },
    onMarkerClicked: (map, marker) => {
      const infoWindow = new google.maps.InfoWindow({
        content: `<div class="map__info-panel"><h3 class="normal">${marker.title}</h3><p class="small">${marker.body}</p></div>`,
        maxWidth: 300,
      });
      infoWindow.open(map, marker);
    },
    autoCenter(map) {
      console.info('GMAP::autocenter');
      const bounds = new google.maps.LatLngBounds();
      AMROP.GMap.markers.forEach((m) => {
        bounds.extend(m.marker.position);
      });
      map.fitBounds(bounds);
      map.panToBounds(bounds);
    },
  };

  class IsotopeGrid {
    constructor(elt) {
      this.DOM = { elt };
      this.init();
    }

    init() {
      const iso = new Isotope(this.DOM.elt, {
        itemSelector: '.js-isotope-item',
        percentPosition: true,
        resizable: false,
        //layoutMode: 'masonry',
        layoutMode: 'fitRows',
        gutter: 10,
      });

      this.DOM.elt.addEventListener('load', () => {
        iso.layout();
      }, true);
      const filters = {};

      var maxHeight = 0;

      document.querySelectorAll('.js-isotope-item .c-card__inner').forEach((element) => {
        var eqipmentHeight = parseInt(element.offsetHeight);
        eqipmentHeight > maxHeight ? maxHeight = eqipmentHeight : false;
      });
      //  const maxHeight =
      document.querySelectorAll('.js-isotope-item .c-card__inner').forEach((element) => {
        element.style.height = maxHeight + "px";
      });
      /*    document.querySelectorAll('.js-isotope-item').forEach((element) => {
           element.style.height = maxHeight +"px";
         });*/

      iso.arrange({});

      document.getElementById('dd-region').addEventListener('change', (e) => {
        const select = e.target;
        const filterGroup = select.getAttribute('data-filter-group');

        filters[filterGroup] = e.target.value;
        const filterValue = concatValues(filters);
        console.log(filterValue);
        iso.arrange({ filter: filterValue });

        const url = location.href.replace(window.location.search + location.hash, "");
        var newurl = url + "?region=" + filterValue.replace(".", "") + "#locations-grid";
        if (newurl != location.href)
          history.pushState({ url: newurl }, null, newurl);
        //   console.log("newurl"+newurl);        
      });
    }
  }

  class Offices {
    constructor() {
      this.$locations = document.querySelector('.c-locations');
      this.$map = document.querySelector('.gmap-wrapper');
      this.$regionsList = document.querySelector('#locations-grid-by-region');

      this.$startLocations = this.$locations.classList.value;
      this.$startMap = this.$map.classList.value;
      this.$startRegionsList = this.$regionsList.classList.value;
      this.init();
    }

    updateOfficesView() {
      var hash = window.location.hash;
      const self = this;
      //console.log("onhashchange "+ hash);
      if (hash === "") {
        console.log("onhashchange empty $startLocations:" + self.$startLocations);
        self.$locations.classList.value = self.$startLocations;
        self.$map.classList.value = self.$startMap;
        self.$regionsList.classList.value = self.$startRegionsList;
      } else {
        if (hash == "#locations-grid-by-region") {
          self.$locations.classList.add('is-collapsed');
          self.$map.classList.add('is-collapsed');
          if (self.$regionsList !== null) {
            self.$regionsList.classList.remove('is-collapsed');
          }
        }
        if (hash == "#locations-grid") {
          self.$map.classList.add('is-collapsed');
          self.$locations.classList.remove('is-collapsed');
          if (self.$regionsList !== null) {
            self.$regionsList.classList.add('is-collapsed');
          }
          var filterValue = window.location.search;
          if (filterValue !== null) {
            filterValue = filterValue.replace("?region=", ".");
          }
          else {
            filterValue = "";
          }
          //console.log("locations-grid "+ filterValue);

          const ddregion = document.getElementById('dd-region');
          ddregion.value = filterValue;
          ddregion.dispatchEvent(new Event('change'));
        }
        if (hash == "#gmap-wrapper" && document.querySelector('.toggle-map')) {
          self.$map.classList.remove('is-collapsed');
          self.$locations.classList.add('is-collapsed');
          if (self.$regionsList !== null) {
            self.$regionsList.classList.add('is-collapsed');
          }
        }
      }
    }

    onHistoryChange(event) {
      // event.preventDefault();
      event.stopPropagation();
      //console.log('On History Change');
      this.updateOfficesView();
    }

    init() {
      const self = this;
      self.updateOfficesView();

      if (window.document.documentMode) {
        // This is IE, use hashchange instead
        window.addEventListener('hashchange', self.onHistoryChange.bind(self), false);
      } else {
        window.addEventListener('popstate', self.onHistoryChange.bind(self), false);
      }

      if (document.querySelector('.toggle-list')) {
        const toggleListBtns = document.querySelectorAll('.toggle-list')
        toggleListBtns.forEach(elt => {
          elt.addEventListener('click', () => {
            const url = location.href.replace(window.location.search + location.hash, "");
            if (self.$locations.classList.contains('is-collapsed')) {
              if (self.$regionsList !== null) {
                self.$regionsList.classList.remove('is-collapsed');
                self.$map.classList.add('is-collapsed');
                // scrollToId('#locations-grid-by-region');
                var newurl = url + "#locations-grid-by-region";
                history.pushState({ url: newurl }, null, newurl);
                //console.log("newurl"+newurl);

              }
              else {
                self.$locations.classList.remove('is-collapsed');
                self.$map.classList.add('is-collapsed');
                //  scrollToId('#locations-grid');
                var newurl = url + "#locations-grid";
                history.pushState({ url: newurl }, null, newurl);
                //console.log("newurl"+newurl);
              }
            } else {
              self.$locations.classList.add('is-collapsed');
              self.$map.classList.remove('is-collapsed');
            }
          });
        });
      }

      if (document.querySelector('.toggle-map')) {

        /*  if(typeof window.location.hash != "undefined" && window.location.hash == "#gmap-wrapper"){
            $map.classList.remove('is-collapsed');
            $locations.classList.add('is-collapsed');              
            if($regionsList !== null){
              $regionsList.classList.add('is-collapsed'); 
            }
            console.log("#gmap-wrapper");
          }*/

        const toggleMapBtns = document.querySelectorAll('.toggle-map')
        toggleMapBtns.forEach(elt => {
          elt.addEventListener('click', () => {
            if (self.$map.classList.contains('is-collapsed')) {
              self.$map.classList.remove('is-collapsed');
              self.$locations.classList.add('is-collapsed');
              if (self.$regionsList !== null) {
                self.$regionsList.classList.add('is-collapsed');
              }
              const url = location.href.replace(window.location.search + location.hash, "");
              //   scrollToId('#gmap-wrapper');
              var newurl = url + "#gmap-wrapper";
              history.pushState({ url: newurl }, null, newurl);
              //console.log("newurl"+newurl);
            } else {
              self.$map.classList.add('is-collapsed');
              self.$locations.classList.remove('is-collapsed');
            }
          });
        });
      }

      if (document.querySelector('.region-card')) {
        const cardsRegionBtns = document.querySelectorAll(".region-card");
        cardsRegionBtns.forEach(elt => {
          elt.addEventListener('click', (e) => {
            if (e.currentTarget.classList.contains("c-card")) {
              const select = e.currentTarget;
              const filterValue = select.getAttribute('data-filter-group');
              const url = location.href.replace(window.location.search + location.hash, "");
              //console.log("filterValue: "+ filterValue);
              if (filterValue !== null) {
                document.querySelector('#locations-grid-by-region').classList.add('is-collapsed');

                self.$regionsList.classList.add('is-collapsed');
                self.$locations.classList.remove('is-collapsed');
                //    scrollToId('#locations-grid');
                var newurl = url + "?region=" + filterValue.replace(".", "") + "#locations-grid";
                history.pushState({ url: newurl }, null, newurl);
                //console.log("newurl"+newurl);

                const ddregion = document.getElementById('dd-region');
                ddregion.value = filterValue;
                ddregion.dispatchEvent(new Event('change'));

              }
            }
          });
        });
      }
    }
  }


  function init() {
    AMROP.mainNav = new MainNav();
    AMROP.sideNav = new SideNav();
    AMROP.scrollPlugin = ScrollToPlugin;
    gsap.registerPlugin(ScrollToPlugin);
    console.log(AMROP.Util.hasTouchScreen(), winSize.width)

    if ((!AMROP.Util.hasTouchScreen() && winSize.width > SCREENMDMAX) || winSize.width > SCREENMDMAX) {
      AMROP.stickyNav = new StickyNav();
    }

    if (AMROP.Util.hasTouchScreen() || winSize.width <= TABLET_LANDSCAPE) {
      AMROP.footerMenu = [];
      document.querySelectorAll('.c-accordion-menu--sm').forEach((element) => {
        AMROP.footerMenu.push(new AccordionMenu(element));
      });
    }

    if (document.querySelector('.js-carousel-wrapper')) {
      document.querySelectorAll('.js-carousel-wrapper').forEach((element) => {
        AMROP.carousels = new Carousels(element);
      });
    }

    AMROP.search = new Search('.c-search');
    AMROP.siteSelector = new SiteSelector('.c-site-selector');
    if (document.querySelector('.js-card-reveal')) {
      AMROP.cardReveals = [];
      document.querySelectorAll('.js-card-reveal').forEach((element) => {
        AMROP.cardReveals.push(new CardReveal(element));
      });
    }

    if (document.getElementById('gmap')) {
      AMROP.GMap.load();
    }

    if (document.querySelectorAll('.c-accordion-menu:not(.c-accordion-menu--sm)')) {
      AMROP.accordionMenu = [];
      document.querySelectorAll('.c-accordion-menu:not(.c-accordion-menu--sm)').forEach((element) => {
        AMROP.accordionMenu.push(new AccordionMenu(element));
      });
    }

    if (document.querySelectorAll('.c-side-filter .c-accordion-menu')) {
      AMROP.accordionMenu = (typeof AMROP.accordionMenu !== 'undefined') ? [] : AMROP.accordionMenu;
      document.querySelectorAll('.c-side-filter .c-accordion-menu').forEach((element) => {
        AMROP.accordionMenu.push(new AccordionMenu(element));
      });
    }

    document.querySelectorAll('.js-grid').forEach((elt) => {
      AMROP.isotope = new IsotopeGrid(elt);
    });

    if (document.querySelector('.c-locations')) {
      AMROP.offices = new Offices();
    }

    if (document.querySelector('.c-consent')) {
      AMROP.consent = new CookieConsent(document.querySelector('.c-consent'));
    }

    //DROPDOW LINKS
    if (document.querySelector('select.dd-links')) {
      const linksDDMs = document.querySelectorAll('select.dd-links');
      linksDDMs.forEach(elt => {
        elt.addEventListener('change', (e) => {
          if (e.target.value !== '') {
            window.location = e.target.value;
          }
        });
      });

      let selUrl = location.pathname + location.search;
      let selUrlsplit = selUrl.split("&p=");
      selUrl = selUrlsplit.length > 0 ? selUrlsplit[0] : selUrl;
      let option = document.querySelector("select > option[value='" + selUrl + "']");

      // assign the option value to the select element if such exists.
      if (option) {
        linksDDMs.forEach(elt => {
          if (elt.querySelector("option[value='" + selUrl + "']")) {
            elt.value = option.value;
          }
        });
      }
    }

    // hijack link with anchors & scroll to
    document.querySelectorAll('a[href^="#"]').forEach((elt) => {
      elt.addEventListener('click', (e) => {
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        if (href !== undefined) {
          const target = href.split('#')[1];
          if (document.getElementById(target) !== null) {
            scrollTo(document.getElementById(target));
          }
        }
      });
    });


  }

  AMROP.Util = {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_device_detection
    hasTouchScreen: () => {
      let hasTouch = false;
      if ('ontouchstart' in window) {
        hasTouch = true;
      } else if ("maxTouchPoints" in navigator) {
        hasTouch = navigator.maxTouchPoints >= 1 && navigator.maxTouchPoints <= 10;
      } else if ("msMaxTouchPoints" in navigator) {
        hasTouch = navigator.msMaxTouchPoints > 0;
      } else {
        var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
        if (mQ && mQ.media === "(pointer:coarse)") {
          hasTouch = !!mQ.matches;
        } else if ('orientation' in window) {
          hasTouch = true; // deprecated, but good fallback
        } else {
          // Only as a last resort, fall back to user agent sniffing
          var UA = navigator.userAgent;
          hasTouch = (
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
          );
        }
      }
      return hasTouch;
    },
    getRandomInt: (min, max) => Math.floor(Math.random() * ((max - min) + 1)) + min,
  };
  document.addEventListener('DOMContentLoaded', () => {
    calcWinSize();
    init();
  });
})();
